<template>
    <v-dialog :value="showDialog" max-width="320">
        <v-card>
            <v-card-title class="headline pr-3">
                <span>{{ $t("Members list") }}</span>
                <v-spacer></v-spacer>
                <icon-button
                    icon="X"
                    @click="$emit('close')"
                />
            </v-card-title>
            <v-card-text class="body-1">
                <v-row v-for="person in group_members" :key="person.id">
                    <v-col class="col-12 pb-2 pt-1">
                        <v-avatar :color="person.avatar ? 'white' : 'grey lighten-2'" size="24" class="mr-3">
                            <img v-if="person.avatar" :alt="person.initials" :src="baseUrl + person.avatar" />
                            <span v-else class="caption blue-grey--text text--darken-1">
                                {{ person.initials }}
                            </span>
                        </v-avatar>
                        {{ person.full_name ? person.full_name : (person.name + " " + person.surname).trim() }}
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref } from "@vue/composition-api";
import AppModule from "../store/modules/app";
import AccountModule from "../store/modules/account";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default {
    name: "AccountGroupMembersDialog",
    components: {},
    props: {
        baseUrl: {
            type: String,
            required: true
        },
        groupId: {
            type: Number,
            required: true
        },
        showDialog: {
            type: Boolean,
            required: true
        }
    },
    setup(props) {
        const appModule = AppModule();
        const accountModule = AccountModule();
        const group_members = ref([]);

        accountModule
            .getGroupMembers(props.groupId)
            .then(function(resp) {
                group_members.value = resp;
            })
            .catch(function(ex) {
                errorDialog.showError(ex);
            });

        return {
            group_members
        };
    }
};
</script>
